import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SendingCollectorClass;
function SendingCollector() {
  if (SendingCollectorClass === VOID) {
    class $ {
      constructor(channel) {
        this.x1g_1 = channel;
      }
      *w1d(value, $completion) {
        return yield* this.x1g_1.c1b(value, $completion);
      }
    }
    initMetadataForClass($, 'SendingCollector', VOID, VOID, [FlowCollector()], [1]);
    SendingCollectorClass = $;
  }
  return SendingCollectorClass;
}
//region block: exports
export {
  SendingCollector as SendingCollector33jb503i6hglm,
};
//endregion

//# sourceMappingURL=SendingCollector.mjs.map
